import { Text } from '@awaze/design-system.components.text';
import styled from 'styled-components';
export const AnchorStyled = styled.a `
  display: grid;
  grid-template-rows: auto 1fr;
  text-decoration: none;
  color: ${({ theme }) => theme.ColorThemeLink};
  &:hover {
    cursor: pointer;
    text-decoration: underline;
  }
  max-width: 192px;
`;
export const ImageStyled = styled.img `
  width: 100%;
  display: flex;
  object-fit: cover;
  border-radius: 8px;
  height: 141px;
  &:not([src]) {
    visibility: hidden;
  }
`;
export const TextStyled = styled(Text) `
  padding-top: 8px;
  line-height: 24px;
  font-weight: ${({ theme }) => theme.FontHeadingHeading600FontWeight};
`;
//# sourceMappingURL=image-link.styles.js.map